
export enum FileConverter {
  PREVIEW_FILE_START = "PREVIEW_FILE_START",
  PREVIEW_FILE_SUCCESS = "PREVIEW_FILE_SUCCESS",
  PREVIEW_FILE_FAIL = "PREVIEW_FILE_FAIL",

  IMPORT_FILE_START = "IMPORT_FILE_START",
  IMPORT_FILE_SUCCESS = "IMPORT_FILE_SUCCESS",
  IMPORT_FILE_FAIL = "IMPORT_FILE_FAIL",

  GET_MAPPING_PROFILES_START = "GET_MAPPING_PROFILES_START",
  GET_MAPPING_PROFILES_SUCCESS = "GET_MAPPING_PROFILES_SUCCESS",
  GET_MAPPING_PROFILES_FAIL = "GET_MAPPING_PROFILES_FAIL",

  RESET_FILE_IMPORT = "RESET_FILE_IMPORT",

  UPDATE_FILE_LIST = "UPDATE_FILE_LIST"
}